window.addEventListener('DOMContentLoaded', function(event){

    if(document.querySelector('.hasAnim')) {

        observeAnim()

    }

    if(document.querySelector('.productHeader__graphic') && window.innerWidth > 975) {

        graphicAnim()

    }

})

function observeAnim() {

	const targets = document.querySelectorAll('.hasAnim');

    if(targets) {
        targets.forEach(function(target) {

            var intersectionObserver = new IntersectionObserver(function(entries) {

                const [{ isIntersecting }] = entries;
    
                if (isIntersecting) {
    
                    target.classList.add('anim');
    
                    intersectionObserver.disconnect();
                    
                }
    
            });
            intersectionObserver.observe(target);
    
        });
    }

}

function graphicAnim() {

    const productHeader = document.querySelector('.productHeader')
    const graphic = productHeader.querySelector('.productHeader__graphic')

    const offset = productHeader.getBoundingClientRect().top + productHeader.getBoundingClientRect().height - 249 * 2

    const myInterval = setInterval(() => {

        if(window.scrollY > offset) {
            graphic.classList.add('hidden')
        } else {
            graphic.classList.remove('hidden')
        }

    }, 20)

}